import {Phone} from './Phone';
import {Image} from './Image';
import {Button} from './Button';
import {Features} from './Features';
import {Assistance} from './Assistance';

export const components = {
  Phone,
  Image,
  Button,
  Features,
  Assistance,
};
